import { render, staticRenderFns } from "./LeadsTableActions.vue?vue&type=template&id=59ad6d98&scoped=true"
import script from "./LeadsTableActions.vue?vue&type=script&lang=ts"
export * from "./LeadsTableActions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad6d98",
  null
  
)

export default component.exports